export const uistateConstants = {
  //
	UPDATE_UI_STATE: "UPDATE_UI_STATE",
	//
	UPDATE_BULK_UI_STATE: "UPDATE_BULK_UI_STATE",
	//
	RESET_TO_DEFAULT: "RESET_TO_DEFAULT",
};